// extracted by mini-css-extract-plugin
module.exports = {"root":"terms-of-service_root__39eGG"};